import React from 'react';


export const ProgressBarsContext = React.createContext();
